import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import low from 'lowlight';
import visit from 'unist-util-visit';
export default function attacher() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      include = _ref.include,
      exclude = _ref.exclude,
      prefix = _ref.prefix;

  return function (ast) {
    return visit(ast, 'code', visitor);
  };

  function visitor(node) {
    var lang = node.lang,
        data = node.data;

    if (!lang || include && !include.includes(lang) || exclude && exclude.includes(lang)) {
      return;
    }

    if (!data) {
      data = {};
      node.data = data;
    }

    if (!data.hProperties) {
      data.hProperties = {};
    }

    data.hChildren = low.highlight(lang, node.value, {
      prefix: prefix
    }).value;
    data.hProperties.className = ['hljs'].concat(_toConsumableArray(data.hProperties.className || []), ['language-' + lang]);
  }
}